<div class="auth">
  <div class="auth-glow" aria-hidden="true"></div>

  <div class="auth-card">
    <span class="brand">
      <svg class="brand-plane" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2 13l9-2 4-8 1 0-2 8 7 1 0 1-7 1 2 8-1 0-4-8-9-2 0-1z" fill="currentColor"/>
      </svg>
      <span class="brand-word">iFly<span class="brand-word-accent">Finance</span></span>
    </span>

    <div *ngIf="!isSubmitted">
      <p class="eyebrow">Account recovery</p>
      <h1 class="hero-title">Forgot password</h1>
      <p class="hero-sub">Enter your email and we'll send you a password reset link.</p>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="auth-form">
        <mat-form-field appearance="outline" class="ifq-field">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="Enter your email address"
            autocomplete="email"
            required>
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('email')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>

        <button
          type="submit"
          class="cta cta--block"
          [disabled]="forgotPasswordForm.invalid || isLoading">
          <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
          <span *ngIf="!isLoading">Send Reset Link</span>
        </button>

        <div class="auth-links">
          <a class="text-link" role="button" tabindex="0"
             (click)="backToLogin()"
             (keydown.enter)="backToLogin()"
             (keydown.space)="$event.preventDefault(); backToLogin()">
            <mat-icon aria-hidden="true">arrow_back</mat-icon>
            Back to Login
          </a>
        </div>
      </form>
    </div>

    <div *ngIf="isSubmitted" class="success-container">
      <div class="success-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h3>Check Your Email</h3>
      <p>We've sent a password reset link to your email address.</p>
      <p class="email-note">If you don't see it, check your spam folder.</p>

      <div class="success-actions">
        <button
          type="button"
          class="cta cta--block"
          (click)="backToLogin()">
          Back to Login
        </button>
      </div>
    </div>
  </div>
</div>
